import saveAs from "file-saver";

export const BlobFile = (file: File, nameFile: string) =>{
    let blob = new Blob([file], { type: 'application/json' })
    return saveAs(blob, nameFile);
}
